/**
 * Parse a store-sourced id-ish value (string | number | empty) to a number,
 * or null when absent/unparseable. Shared by the coach and producer Knock
 * surfaces (review finding 2026-07-02: the two private copies could drift and
 * silently kill one surface's feed).
 */
var toNumberOrNull = function (value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    var parsed = parseInt(String(value), 10);
    return Number.isNaN(parsed) ? null : parsed;
};
export default toNumberOrNull;
